// import lib
import { Signal, EmptyCallback } from 'ln/signal/Signal';
import View from 'ln/view/View';

export interface TimeUpdate{
	( time:number )
}

export interface DurationUpdate{
	( duration:number )
}

export interface VolumeUpdate{
	( volume:number )
}

export interface VideoFileModel{
	id:number;
	ext:string;
	filename:string;
}

/**
 * Wrapper for the html5 video-tag
 */
export class VideoPlayer extends View {
	
	public video:HTMLVideoElement;

	public time:Signal<TimeUpdate> = new Signal<TimeUpdate>();
	public duration:Signal<DurationUpdate> = new Signal<DurationUpdate>();
	public volume:Signal<VolumeUpdate> = new Signal<VolumeUpdate>();
	public playing:Signal<EmptyCallback> = new Signal<EmptyCallback>();
	public pausing:Signal<EmptyCallback> = new Signal<EmptyCallback>();
	public ended:Signal<EmptyCallback> = new Signal<EmptyCallback>();

	constructor() {

		super();

		this.defaultTemplate = 'lv.video-player';
	}


	init() {

		this.video = <HTMLVideoElement> this.node.one( 'video' ).native;

		this.video.ondurationchange = () => {
			this.duration.dispatch( this.video.duration );
		};

		this.video.ontimeupdate = () => {
			this.time.dispatch( this.video.currentTime );
		}

		this.video.onvolumechange = () => {
			this.volume.dispatch( this.video.volume );
		}

		this.video.onplay = () => {
			this.playing.dispatch();
		};
		this.video.onpause = () => {
			this.pausing.dispatch();
		};
		this.video.onended = () => {
			this.ended.dispatch();
		};
	}

	/** Gets the current playback time in seconds. */
	get currentTime(): number {
		return this.video.currentTime;
	}

	public play() {
		this.video.play();
	}

	public load( url:string ) {
		this.node.one( 'source' ).setAttribute( 'src', url );
		this.video.load();
	}

	public pause() {
		this.video.pause();
	}

	get paused():boolean{
		return this.video.paused;
	}

	public toggleMute() {
		this.video.muted = !this.video.muted;
	}


	public moveToPercentage( percentage:number ){
		percentage = Math.min( 100, Math.max( 0, percentage ) );
		this.video.currentTime = this.video.duration * percentage / 100;
	}

	public moveToTime( time:number ){
		time = Math.min( this.video.duration, Math.max( 0, time ) );
		this.video.currentTime = time;
	}
}

export default VideoPlayer